function CollapseView({ stock, onView }) {
  return (
    <div className="border p-3 rounded bg-white">
      <div className="mb-3">
        <p className="mb-1">
          <strong>OR #:</strong> {stock?.orNumber}
        </p>
        <p className="mb-1">
          <strong>SKU:</strong> {stock?.sku}
        </p>
        <p className="mb-1">
          <strong>Raw Material Name:</strong> {stock?.name}
        </p>
        <p className="mb-1">
          <strong>Quantity:</strong> {stock?.quantity}
        </p>
        <p className="mb-1">
          <strong>Amount:</strong> {stock?.amount}
        </p>
        <p className="mb-1">
          <strong>Void Date:</strong>{" "}
          {stock?.voidDate &&
            new Date(stock?.voidDate).toLocaleString("en-US", {
              month: "long", // March
              day: "numeric", // 2
              year: "numeric", // 2025
              hour: "numeric", // 5
              minute: "2-digit", // 15
              hour12: true, // am/pm
            })}
        </p>
      </div>

      <div className="d-flex gap-2">
        <button className="btn btn-success text-white" onClick={onView}>
          <i className="bi bi-eye me-2"></i> View
        </button>
        {/* <button className="btn btn-danger" onClick={onDelete}>
          <i className="bi bi-trash-fill me-2"></i> Delete
        </button> */}
      </div>
    </div>
  );
}

export default CollapseView;
